import { Observable } from "rxjs";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { getErrorMessage, getRequestCode } from "./errorParser";
export default function createItemFetcher(urlComputer, nameSpace, computeItemId, bodyParser = (a) => a) {
    const ActionKeys = {
        SET_ITEM: `${nameSpace}/SET`,
        DELETE_ITEM: `${nameSpace}/DELETE`,
        UPDATE_ITEM: `${nameSpace}/UPDATE`,
        FETCH_ITEM: `${nameSpace}/FETCH_START`,
        FETCH_ITEM_ERROR: `${nameSpace}/FETCH_ERROR`,
        FETCH_ITEM_PENDING: `${nameSpace}/FETCH_PENDING`,
    };
    const fetchItem = (payload) => ({
        type: ActionKeys.FETCH_ITEM,
        payload,
    });
    const deleteItem = (config) => {
        const id = computeItemId(config);
        return {
            type: ActionKeys.DELETE_ITEM,
            id,
        };
    };
    const updateItem = (config, payload) => {
        const id = computeItemId(config);
        return {
            type: ActionKeys.UPDATE_ITEM,
            id,
            payload,
        };
    };
    const setItemFetchError = (config, errorMessage, errorCode) => {
        const id = computeItemId(config);
        return {
            type: ActionKeys.FETCH_ITEM_ERROR,
            id,
            errorMessage,
            errorCode,
        };
    };
    const setItem = (config, payload) => {
        const id = computeItemId(config);
        return {
            type: ActionKeys.SET_ITEM,
            id,
            payload,
        };
    };
    const setItemFetchPending = (config) => {
        const id = computeItemId(config);
        return {
            type: ActionKeys.FETCH_ITEM_PENDING,
            id,
        };
    };
    const actions = {
        fetchItem,
        setItemFetchError,
        setItemFetchPending,
        setItem,
        deleteItem,
        updateItem,
    };
    const initialState = {};
    function reducer(state = initialState, action) {
        let currentItem;
        switch (action.type) {
            case ActionKeys.SET_ITEM:
                currentItem = state[action.id] || {};
                return Object.assign({}, state, {
                    [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.READY, errorMessage: "", content: action.payload }),
                });
            case ActionKeys.DELETE_ITEM:
                const currentState = Object.assign({}, state);
                delete currentState[action.id];
                return currentState;
            case ActionKeys.UPDATE_ITEM:
                currentItem = state[action.id] || {};
                return Object.assign({}, state, {
                    [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.READY, errorMessage: "", content: Object.assign(Object.assign({}, currentItem.content), action.payload) }),
                });
            case ActionKeys.FETCH_ITEM_ERROR:
                currentItem = state[action.id] || {};
                return Object.assign({}, state, {
                    [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.ERROR, errorMessage: action.errorMessage, content: {}, errorCode: action.errorCode }),
                });
            case ActionKeys.FETCH_ITEM_PENDING:
                currentItem = state[action.id] || {};
                return Object.assign({}, state, {
                    [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.PENDING, errorMessage: "", content: {} }),
                });
            default:
                return state;
        }
    }
    function getItem(state, config) {
        const id = computeItemId(config);
        return state[id] && state[id].content;
    }
    function isItemLoaded(state, config) {
        const id = computeItemId(config);
        const item = state[id] || { status: ItemStatus.PENDING };
        return item.status !== ItemStatus.PENDING;
    }
    function hasItemError(state, config) {
        const id = computeItemId(config);
        const item = state[id] || { status: null };
        return item.status === ItemStatus.ERROR;
    }
    function getItemError(state, config) {
        const id = computeItemId(config);
        const item = state[id] || { errorMessage: null };
        return item.errorMessage;
    }
    function getItemRequestCode(state, config) {
        const id = computeItemId(config);
        const item = state[id] || { errorCode: null };
        return item.errorCode;
    }
    function getStatus(state, config) {
        const id = computeItemId(config);
        const status = state[id] && state[id].status;
        return status || ItemStatus.PENDING;
    }
    const selectors = {
        getItem,
        isItemLoaded,
        hasItemError,
        getItemError,
        getStatus,
        getItemRequestCode,
    };
    const fetchItemEpic = (action$, _, { ajax }) => action$.ofType(ActionKeys.FETCH_ITEM).mergeMap((action) => ajax
        .getJSON(urlComputer(action.payload))
        .map((response) => setItem(action.payload, bodyParser(response)))
        .catch((error) => Observable.of(setItemFetchError(action.payload, getErrorMessage(error), getRequestCode(error))))
        .startWith(setItemFetchPending(action.payload)));
    const middleware = [fetchItemEpic];
    return { actions, reducer, middleware, selectors, ActionKeys };
}
//# sourceMappingURL=item.js.map